import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

let map;
let markers = [];
let resizeObserver;
let mapInitTimeout;

function fitBoundsToMarkers(markerData) {
    if (!map || markerData.length === 0) return;

    const bounds = new mapboxgl.LngLatBounds();
    markerData.forEach(md => {
        bounds.extend(md.coords);
    });

    map.fitBounds(bounds, { padding: 100 });
}

function destroyMap() {
    // Limpiar observador
    if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
    }

    // Limpiar timeout
    if (mapInitTimeout) {
        clearTimeout(mapInitTimeout);
        mapInitTimeout = null;
    }

    // Limpiar mapa
    if (map) {
        try {
            map.remove();
        } catch (e) {
            console.error("Error removiendo mapa:", e);
        }
        map = null;
        markers = [];
    }
}

window.initializeSectionMap = function() {
    const mapElement = document.getElementById("map");
    const mapContainer = document.getElementById("sectioncardMap");
    
    if (!mapElement || !mapContainer) {
        console.warn("Map elements not found");
        return;
    }

    // Limpiar cualquier mapa o timeout anterior
    destroyMap();

    // Vaciar el contenedor
    mapElement.innerHTML = '';

    const accessToken = mapContainer?.dataset.accessToken;
    if (!accessToken) {
        console.warn("No access token found");
        return;
    }

    mapboxgl.accessToken = accessToken;

    // Solo mostrar tarjetas visibles (no ocultas por filtros)
    const cardElements = document.querySelectorAll(".card-item:not(.hidden)");
    const markerData = [];

    cardElements.forEach(card => {
        const lat = parseFloat(card.dataset.lat);
        const lon = parseFloat(card.dataset.lon);
        const name = card.dataset.name;

        if (!isNaN(lat) && !isNaN(lon)) {
            markerData.push({
                coords: [lon, lat],
                name: name,
            });
        }
    });

    if (markerData.length === 0) {
        mapElement.innerHTML = "<p style='padding: 20px;'>No hay ubicaciones disponibles</p>";
        return;
    }

    // Esperar a que el layout se recalcule después de display:none -> display:flex
    requestAnimationFrame(() => {
        // Pequeño delay para asegurar que las dimensiones se actualicen
        mapInitTimeout = setTimeout(() => {
            // Validar que el contenedor tiene dimensiones reales
            const containerHeight = mapContainer.offsetHeight;
            const containerWidth = mapContainer.offsetWidth;

            if (containerHeight === 0 || containerWidth === 0) {
                console.warn("Container has no dimensions, forcing 600px height");
                mapContainer.style.height = '600px !important';
            }

            // Calcular centro del mapa
            const avgLng = markerData.reduce((sum, m) => sum + m.coords[0], 0) / markerData.length;
            const avgLat = markerData.reduce((sum, m) => sum + m.coords[1], 0) / markerData.length;

            try {
                map = new mapboxgl.Map({
                    container: "map",
                    style: "mapbox://styles/mapbox/streets-v11",
                    center: [avgLng, avgLat],
                    zoom: 10,
                });

                map.on("load", () => {
                    markers = [];

                    markerData.forEach(md => {
                        const popup = new mapboxgl.Popup({ offset: 50 })
                            .setHTML(`<strong>${md.name}</strong>`);

                        const marker = new mapboxgl.Marker()
                            .setLngLat(md.coords)
                            .setPopup(popup)
                            .addTo(map);

                        markers.push({ marker, name: md.name });

                        marker.getElement().addEventListener("click", () => {
                            popup.addTo(map);
                            const targetCard = document.querySelector(`.card-item[data-name="${md.name}"]`);
                            if (targetCard && !targetCard.classList.contains("hidden")) {
                                targetCard.scrollIntoView({ behavior: "smooth", block: "start" });
                                targetCard.classList.add("highlight");
                                setTimeout(() => targetCard.classList.remove("highlight"), 1500);
                            }
                        });
                    });

                    // Ajustar mapa a los marcadores
                    fitBoundsToMarkers(markerData);
                });

                map.on("error", (e) => {
                    console.error("Error en el mapa:", e);
                });

                // Monitorear cambios de tamaño del contenedor
                if (ResizeObserver) {
                    resizeObserver = new ResizeObserver(() => {
                        if (map) {
                            map.resize();
                        }
                    });
                    resizeObserver.observe(mapContainer);
                }
            } catch (error) {
                console.error("Error al inicializar el mapa:", error);
                destroyMap();
            }
        }, 50);
    });
};

// Actualizar mapa sin reinicializar (solo ocultar marcadores)
window.updateSectionMap = function() {
    if (!map) return;

    const cardElements = document.querySelectorAll(".card-item:not(.hidden)");
    const visibleNames = new Set();
    const visibleMarkers = [];

    cardElements.forEach(card => {
        const lat = parseFloat(card.dataset.lat);
        const lon = parseFloat(card.dataset.lon);
        const name = card.dataset.name;

        if (!isNaN(lat) && !isNaN(lon)) {
            visibleNames.add(name);
            visibleMarkers.push({ coords: [lon, lat], name });
        }
    });

    // Ocultar/Mostrar marcadores
    markers.forEach(m => {
        if (visibleNames.has(m.name)) {
            m.marker.getElement().style.display = "";
        } else {
            m.marker.getElement().style.display = "none";
        }
    });

    // Ajustar bounds solo a los marcadores visibles
    if (visibleMarkers.length > 0) {
        fitBoundsToMarkers(visibleMarkers);
    }
};

// Escuchar filtros desde app-public.js
window.addEventListener("sectionTagsFilter", (e) => {
    // console.log("Evento sectionTagsFilter recibido:", e);
    
    const detail = e.detail || {};
    const { selectedTags = [], searchTerm = "" } = detail;

    // console.log("Parámetros recibidos:", { selectedTags, searchTerm });

    // Filtrar tarjetas - INCLUIR CAMPOS DE DIRECCIÓN
    document.querySelectorAll(".card-item").forEach(card => {
        const cardName = (card.dataset.name || "").toLowerCase().trim();
        const cardTags = JSON.parse(card.dataset.tags || "[]");
        const cardDescription = (card.textContent || "").toLowerCase().trim();
        const cardCountry = (card.dataset.addressCountry || "").toLowerCase().trim();
        const cardProvince = (card.dataset.addressProvince || "").toLowerCase().trim();
        const cardLocality = (card.dataset.addressLocality || "").toLowerCase().trim();

        // Filtro de búsqueda - incluir campos de dirección
        let matchesSearch = true;
        if (searchTerm.length > 0) {
            matchesSearch = 
                cardName.indexOf(searchTerm) !== -1 || 
                cardDescription.indexOf(searchTerm) !== -1 ||
                (cardCountry.length > 0 && cardCountry.indexOf(searchTerm) !== -1) ||
                (cardProvince.length > 0 && cardProvince.indexOf(searchTerm) !== -1) ||
                (cardLocality.length > 0 && cardLocality.indexOf(searchTerm) !== -1);
        }

        // Filtro de tags
        const matchesTags = selectedTags.length === 0 || cardTags.some(t => selectedTags.includes(t));

        if (matchesSearch && matchesTags) {
            card.classList.remove("hidden");
            // IMPORTANTE: Remover el inline style display que podría estar bloqueando
            if (card.style.display === 'none') {
                card.style.display = '';
            }
        } else {
            card.classList.add("hidden");
        }
    });

    // Si el mapa está visible, actualizar
    const mapContainer = document.getElementById("map-container");
    if (mapContainer && mapContainer.classList.contains("active")) {
        // console.log("Mapa está activo, actualizando...");
        if (map) {
            window.updateSectionMap?.();
        } else {
            // console.log("Mapa no inicializado, inicializando...");
            window.initializeSectionMap?.();
        }
    }
});

// Eventos de interfaz para cambios de vista
document.addEventListener("DOMContentLoaded", () => {
    const toggleFiltersBtn = document.getElementById("toggleFiltersBtn");
    const sidebar = document.getElementById("filters-sidebar");
    const viewToggleBtn = document.getElementById("viewToggleBtn");
    const cardsContainer = document.getElementById("cards-container");
    const mapContainer = document.getElementById("map-container");
    const clearFiltersBtn = document.getElementById("clear-filters");
    const tagFilters = document.querySelectorAll(".tag-filter");

    let isMapView = false; // Estado inicial: vista listado

    // Toggle sidebar
    if (toggleFiltersBtn && sidebar) {
        toggleFiltersBtn.addEventListener("click", () => {
            sidebar.style.display = sidebar.style.display === "none" ? "block" : "none";
            
            // Añadir/remover clase with-filters al contenedor de cards
            if (sidebar.style.display === "block") {
                toggleFiltersBtn.classList.add("active");
                cardsContainer?.classList.add("with-filters");
                mapContainer?.classList.add("with-filters");
            } else {
                toggleFiltersBtn.classList.remove("active");
                cardsContainer?.classList.remove("with-filters");
                mapContainer?.classList.remove("with-filters");
            }
            
            // Si el mapa está activo, hacer resize
            if (map && mapContainer.classList.contains("active")) {
                requestAnimationFrame(() => {
                    map.resize();
                });
            }
        });
    }

    // Toggle entre vista listado y mapa
    if (viewToggleBtn) {
        viewToggleBtn.addEventListener("click", () => {
            isMapView = !isMapView;

            if (isMapView) {
                // Cambiar a vista mapa
                cardsContainer.style.display = "none";
                mapContainer.style.display = "none"; // Asegurar que está oculto primero
                mapContainer.classList.add("active");
                viewToggleBtn.classList.add("active");
                viewToggleBtn.innerHTML = '<i class="bi bi-list-ul"></i> Listado';
                
                // Usar requestAnimationFrame para esperar a que el layout se recalcule
                requestAnimationFrame(() => {
                    // Forzar reflow para actualizar dimensiones
                    void mapContainer.offsetHeight;
                    window.initializeSectionMap?.();
                });
            } else {
                // Cambiar a vista listado
                mapContainer.classList.remove("active");
                mapContainer.style.display = "none"; // Ocultar completamente
                cardsContainer.style.display = "flex";
                viewToggleBtn.classList.remove("active");
                viewToggleBtn.innerHTML = '<i class="bi bi-map"></i> Mapa';
                
                // Destruir el mapa completamente
                destroyMap();
            }
        });
    }

    // Limpiar filtros
    if (clearFiltersBtn) {
        clearFiltersBtn.addEventListener("click", () => {
            tagFilters.forEach(f => f.checked = false);
            // Disparar evento de cambio
            window.dispatchEvent(new Event("sectionTagsFilter", { bubbles: true }));
        });
    }
});
